import { Injectable, NgZone, PLATFORM_ID } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { MarkerInterface } from '../models/marker';
import { Observable } from 'rxjs';
import { FirebaseAppConfig, _firebaseAppFactory } from '@angular/fire';
import { AngularFireDatabase } from '@angular/fire/database';


@Injectable({
  providedIn: 'root'
})

export class MarkersService {

  markersCollection: AngularFirestoreCollection<MarkerInterface>;
  markers: Observable<MarkerInterface[]>;

  private _afs: AngularFirestore;

  constructor(public afs: AngularFirestore, private zone: NgZone) { 
    this.markers = this.afs.collection('places').valueChanges();
  }

  public initFirebase(config: FirebaseAppConfig, firebaseAppName: string){
    this._afs = new AngularFirestore(config, firebaseAppName, false, null, PLATFORM_ID, this.zone, null )
  }

  getMarkers(){
    return this._afs.collection('places').valueChanges(); //aqui cambio por demo
  }
  
  getIOsDetail(ref){
    return this._afs.collection('places').doc(ref).valueChanges();
  }

  getConsumersNames(){
    return this._afs.collection('consumidores').doc('consumidores').valueChanges();
  }

  

  
}
